export default __webpack_public_path__ + "static/media/bhojpuri_cm_2.f95361c0.mp3";